/* Strategy RED – mega menu drawer controller */
(function () {
  'use strict';
  if (window.__srMegaInit) return;
  window.__srMegaInit = true;

  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var HOVER = window.matchMedia('(hover: hover) and (pointer: fine)');
  var HOVER_DELAY = 90;

  function init() {
    var root = document.querySelector('[data-sr-mega]');
    if (!root) return;
    // Move to <body> so position:fixed is never trapped by a transformed/sticky header ancestor.
    if (root.parentElement !== document.body) document.body.appendChild(root);

    var toggles = Array.prototype.slice.call(document.querySelectorAll('[data-sr-mega-toggle]'));
    var header = document.querySelector('[data-header-wrapper]') || document.querySelector('header');
    var hoverTimer = null;
    var lastFocus = null;

    function panel(id) { return document.getElementById(id); }
    function panelsAtLevel(level) { return root.querySelectorAll('[data-sr-level="' + level + '"]'); }

    function setTop() {
      var top = 0;
      if (header) {
        var r = header.querySelector('[data-header-height]') ? header.querySelector('[data-header-height]').getBoundingClientRect() : header.getBoundingClientRect();
        top = Math.max(0, Math.round(r.bottom));
      }
      root.style.setProperty('--sr-top', top + 'px');
    }

    function closeFrom(level) {
      for (var l = level; l <= 3; l++) {
        Array.prototype.forEach.call(panelsAtLevel(l), function (p) {
          if (l > 1) p.hidden = true;
        });
      }
      // reset triggers that point at closed panels
      Array.prototype.forEach.call(root.querySelectorAll('[data-sr-open]'), function (btn) {
        var target = panel(btn.getAttribute('data-sr-open'));
        if (target && target.hidden) btn.setAttribute('aria-expanded', 'false');
      });
    }

    function openPanel(btn, focusFirst) {
      var id = btn.getAttribute('data-sr-open');
      var target = panel(id);
      if (!target) return;
      var level = parseInt(target.getAttribute('data-sr-level'), 10);
      closeFrom(level);
      target.hidden = false;
      target.scrollTop = 0;
      // mark siblings in the same column as collapsed, this one expanded
      var list = btn.closest('.sr-mega__panel');
      Array.prototype.forEach.call(list.querySelectorAll('[data-sr-open]'), function (b) {
        b.setAttribute('aria-expanded', b === btn ? 'true' : 'false');
      });
      if (focusFirst) {
        var first = target.querySelector(DESKTOP.matches ? '.sr-mega__head, .sr-mega__item' : '[data-sr-back]');
        if (first) first.focus();
      }
    }

    // Start loading the desktop panel images as soon as the menu is about to open,
    // so they are ready before a column is hovered (they stay lazy until then).
    var imagesPrimed = false;
    function primeImages() {
      if (imagesPrimed || !DESKTOP.matches) return;
      imagesPrimed = true;
      Array.prototype.forEach.call(root.querySelectorAll('.sr-mega__media img'), function (img) {
        img.loading = 'eager';
        if (img.decode) img.decode().catch(function () {});
      });
    }
    toggles.forEach(function (t) {
      t.addEventListener('mouseenter', primeImages);
      t.addEventListener('focus', primeImages);
      t.addEventListener('touchstart', primeImages, { passive: true });
    });

    function open() {
      primeImages();
      setTop();
      lastFocus = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('sr-mega-lock');
      toggles.forEach(function (t) {
        t.setAttribute('aria-expanded', 'true');
        t.setAttribute('aria-label', 'Close menu');
        var label = t.querySelector('[data-sr-mega-label]');
        if (label) label.textContent = 'Close';
      });
      var first = root.querySelector('.sr-mega__panel--1 .sr-mega__item');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 60);
    }

    function close(restoreFocus) {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('sr-mega-lock');
      closeFrom(2);
      toggles.forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
        t.setAttribute('aria-label', 'Open menu');
        var label = t.querySelector('[data-sr-mega-label]');
        if (label) label.textContent = 'Menu';
      });
      if (restoreFocus !== false && lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function isOpen() { return root.classList.contains('is-open'); }

    toggles.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        isOpen() ? close() : open();
      });
    });

    root.addEventListener('click', function (e) {
      var closeEl = e.target.closest('[data-sr-mega-close]');
      if (closeEl) { close(); return; }

      var back = e.target.closest('[data-sr-back]');
      if (back) {
        var p = back.closest('.sr-mega__panel');
        var lvl = parseInt(p.getAttribute('data-sr-level'), 10);
        closeFrom(lvl);
        var opener = root.querySelector('[data-sr-open="' + p.id + '"]');
        if (opener) opener.focus();
        return;
      }

      var btn = e.target.closest('[data-sr-open]');
      if (btn) {
        var target = panel(btn.getAttribute('data-sr-open'));
        // On desktop a click on an already-open item keeps it open; on touch it toggles.
        if (target && !target.hidden && !DESKTOP.matches) { closeFrom(parseInt(target.getAttribute('data-sr-level'), 10)); return; }
        openPanel(btn, e.detail === 0); // keyboard activation moves focus into the column
        return;
      }

      var leaf = e.target.closest('a[href]');
      if (leaf && leaf.getAttribute('href') === '#') { e.preventDefault(); }
    });

    // Desktop hover intent: hovering an item opens its column (like TaylorMade's Our Offerings / Clubhouse).
    root.addEventListener('mouseover', function (e) {
      if (!DESKTOP.matches || !HOVER.matches) return;
      var item = e.target.closest('.sr-mega__item');
      if (!item) return;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () {
        if (item.hasAttribute('data-sr-open')) {
          if (item.getAttribute('aria-expanded') !== 'true') openPanel(item, false);
        } else {
          // hovering a plain link closes deeper columns opened from this column
          var p = item.closest('.sr-mega__panel');
          var lvl = parseInt(p.getAttribute('data-sr-level'), 10);
          closeFrom(lvl + 1);
          Array.prototype.forEach.call(p.querySelectorAll('[data-sr-open]'), function (b) { b.setAttribute('aria-expanded', 'false'); });
        }
      }, HOVER_DELAY);
    });
    root.addEventListener('mouseleave', function () { clearTimeout(hoverTimer); });

    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') {
        // Esc closes the deepest open column first, then the drawer.
        var open3 = root.querySelector('[data-sr-level="3"]:not([hidden])');
        var open2 = root.querySelector('[data-sr-level="2"]:not([hidden])');
        var deepest = open3 || open2;
        if (deepest && !DESKTOP.matches) {
          closeFrom(parseInt(deepest.getAttribute('data-sr-level'), 10));
          var opener = root.querySelector('[data-sr-open="' + deepest.id + '"]');
          if (opener) opener.focus();
        } else {
          close();
        }
        return;
      }
      if (e.key === 'ArrowRight' && DESKTOP.matches) {
        var b = document.activeElement && document.activeElement.closest && document.activeElement.closest('[data-sr-open]');
        if (b && root.contains(b)) { e.preventDefault(); openPanel(b, true); }
      }
      if (e.key === 'ArrowLeft' && DESKTOP.matches) {
        var cur = document.activeElement && document.activeElement.closest && document.activeElement.closest('.sr-mega__panel');
        if (cur && root.contains(cur) && cur.id) {
          e.preventDefault();
          var op = root.querySelector('[data-sr-open="' + cur.id + '"]');
          if (op) op.focus();
        }
      }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        var col = document.activeElement && document.activeElement.closest && document.activeElement.closest('.sr-mega__panel');
        if (!col || !root.contains(col)) return;
        var items = Array.prototype.slice.call(col.querySelectorAll('.sr-mega__head[href], .sr-mega__item'));
        var i = items.indexOf(document.activeElement);
        if (i === -1) return;
        e.preventDefault();
        var next = items[(i + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length];
        if (next) next.focus();
      }
    });

    window.addEventListener('resize', function () { if (isOpen()) setTop(); });
    DESKTOP.addEventListener && DESKTOP.addEventListener('change', function () { if (isOpen()) closeFrom(2); });
  }

  // The script tag sits right after the drawer markup, so the drawer and toggles already exist
  // when it runs; only fall back to DOMContentLoaded if they don't.
  if (document.querySelector('[data-sr-mega]')) init();
  else document.addEventListener('DOMContentLoaded', init);
})();
